module.exports = {"340281100":"无城镇","340281101":"襄安镇","340281104":"陡沟镇","340281105":"石涧镇","340281106":"严桥镇","340281107":"开城镇","340281108":"蜀山镇","340281109":"牛埠镇","340281110":"刘渡镇","340281111":"姚沟镇","340281112":"泥汊镇","340281114":"福渡镇","340281115":"泉塘镇","340281116":"赫店镇","340281117":"红庙镇","340281118":"高沟镇","340281119":"鹤毛镇","340281120":"十里墩镇","340281121":"昆山镇","340281122":"洪巷镇","340281400":"安徽无为经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340281.json
// module id = 1163
// module chunks = 0